const updates = [
  { time: '10分钟前', title: '51吃瓜网新增3条官方备用入口，访问更稳定快捷', type: '平台' },
  { time: '28分钟前', title: '某综艺节目录制现场路透照流出，嘉宾阵容引热议', type: '综艺' },
  { time: '1小时前', title: '当红男星被拍到深夜出入某小区，疑似新恋情曝光', type: '八卦' },
  { time: '2小时前', title: '热门电视剧大结局收视率创新高，网友直呼意难平', type: '影视' },
  { time: '3小时前', title: '知名网红直播间带货翻车，产品质疑引发全网讨论', type: '网红' },
  { time: '4小时前', title: '51吃瓜网官网入口更新，新增手机端适配优化', type: '平台' },
  { time: '5小时前', title: '某音乐节阵容官宣，多位顶流艺人确认加盟', type: '音乐' },
  { time: '6小时前', title: '热门IP改编电影官宣定档，原著粉丝期待值拉满', type: '影视' },
  { time: '8小时前', title: '某品牌官宣新代言人，粉丝评论区两极分化', type: '时尚' },
];

const typeColors: Record<string, string> = {
  '平台': 'bg-primary-100 text-primary-700',
  '综艺': 'bg-accent-100 text-accent-700',
  '八卦': 'bg-secondary-100 text-secondary-700',
  '影视': 'bg-primary-100 text-primary-700',
  '网红': 'bg-accent-100 text-accent-700',
  '音乐': 'bg-secondary-100 text-secondary-700',
  '时尚': 'bg-primary-100 text-primary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">吃瓜快讯</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">实时滚动更新，不错过任何一条热门资讯</p>

        <div className="max-w-[800px] mx-auto">
          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-px bg-secondary-200"></div>

            <div className="space-y-0">
              {updates.map((item, i) => (
                <div key={i} className="relative flex gap-5 pb-6 last:pb-0">
                  <div className="relative z-10 w-[38px] h-[38px] rounded-full bg-background-50 border-2 border-secondary-300 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1 flex-wrap">
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                      <span className={`text-xs px-1.5 py-0.5 rounded whitespace-nowrap ${typeColors[item.type] || 'bg-secondary-100 text-secondary-700'}`}>{item.type}</span>
                    </div>
                    <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{item.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}